const state = () => ({
    notif: null,
    linhas: null,
    veiculos: null,
    grade: null,
    status: null,
    tempo: null,
});

const getters = {
    notif: (state) => {
        return state.notif;
    },
    linhas: (state) => {
        return state.linhas;
    },
    veiculos: (state) => {
        return state.veiculos;
    },
    grade: (state) => {
        return state.grade;
    },
    status: (state) => {
        return state.status;
    },
    tempo: (state) => {
        return state.tempo;
    },
}

const mutations = {
    resetNotif(state, timeoutId) {
        if (state.notif) {
            clearTimeout(state.notif);
        }
        state.notif = timeoutId;
    },
    resetLinhas(state, timeoutId) {
        if (state.linhas) {
            clearTimeout(state.linhas);
        }
        state.linhas = timeoutId;
    },
    resetVeiculos(state, timeoutId) {
        if (state.veiculos) {
            clearTimeout(state.veiculos);
        }
        state.veiculos = timeoutId;
    },
    resetGrade(state, timeoutId) {
        if (state.grade) {
            clearTimeout(state.grade);
        }
        state.grade = timeoutId;
    },
    resetStatus(state, timeoutId) {
        if (state.status) {
            clearTimeout(state.status);
        }
        state.status = timeoutId;
    },
    resetTempo(state, timeoutId) {
        if (state.tempo) {
            clearTimeout(state.tempo);
        }
        state.tempo = timeoutId;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations
}
